import { ANALYTICS } from 'constants/api';
import axios from 'utils/axios';

export const getTotalCreatedCourses = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchCreatedCourses, {
        params: data
    });
    return result.data;
};

export const getTotalUnitsAnalysed = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchUnitsAnalysed, {
        params: data
    });
    return result.data;
};

export const getTotalQuizzesCompleted = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchQuizzesCompleted, {
        params: data
    });
    return result.data;
};

export const getTotalvgQuizCompletionTime = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchAvgQuizCompletionTime, {
        params: data
    });
    return result.data;
};

export const getTotalLLNReportsGenerated = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchTotalLLNReportsGenerated, {
        params: data
    });
    return result.data;
};

export const getLeanersAboveAcsfLevel3 = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchLeanersAboveAcsfLevel3, {
        params: data
    });
    return result.data;
};

export const getTotalCompletedQuizzesByMonth = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchTotalCompletedQuizzesByMonth, {
        params: data
    });
    return result.data;
};

export const getQuizUsed = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchQuizUsed, {
        params: data
    });
    return result.data;
};

export const getAverageResults = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchAverageResults, {
        params: data
    });
    return result.data;
};

export const getTotalLLNReportsGeneratedByMonth = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchTotalLLNReportsGeneratedByMonth, {
        params: data
    });
    return result.data;
};

export const getDashboardLearnerAnalytics = async (data) => {
    const result = await axios.get(ANALYTICS.v2.fetchDashboardLearnerAnalytics, {
        params: data
    });
    return result.data;
};
